import React, {useEffect, useState, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUp} from "@fortawesome/free-solid-svg-icons/faArrowUp";

import styles from "./ScrollTop.module.scss";
import {config} from "@/config";

export default function ScrollTop() {
  const [show, setShow] = useState(false);
  const root = document.getElementById("root");
  const buttonRef = useRef();

  const isForth = config.websiteId === 1;
  const isEdge = config.websiteId === 2;
  const isBiomarkerTracking = !isForth && !isEdge;

  useEffect(() => {
    if (buttonRef) {
      root.addEventListener("scroll", e => {
        setTimeout(() => {
          root.scrollTop >= 200 && handleShow(true);
          root.scrollTop < 200 && handleShow(false);
        }, 1000);
      });
    }

    return () => {
      root.removeEventListener("scroll", e => {
        setTimeout(() => {
          root.scrollTop >= 200 && handleShow(true);
          root.scrollTop < 200 && handleShow(false);
        }, 1000);
      });
    };
  }, [buttonRef]);

  const handleShow = show => {
    setShow(show);

    if (!show && buttonRef.current) {
      buttonRef.current.classList.add("d-none");
    }

    if (show && buttonRef.current) {
      buttonRef.current.classList.remove("d-none");
    }
  };

  const handleScrollToTop = () => {
    root.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      ref={buttonRef}
      className={`${styles.container} d-none ${show ? styles.fadeIn : styles.fadeOut}`}
      onClick={handleScrollToTop}>
      <FontAwesomeIcon icon={faArrowUp} size="lg" className={isForth || isBiomarkerTracking ? "" : "text-white"} />
      <div className={styles.background}></div>
    </div>
  );
}
